import { render, staticRenderFns } from "./AnswerManage.vue?vue&type=template&id=8cf8abc0&scoped=true&"
import script from "./AnswerManage.vue?vue&type=script&lang=js&"
export * from "./AnswerManage.vue?vue&type=script&lang=js&"
import style0 from "./AnswerManage.vue?vue&type=style&index=0&id=8cf8abc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf8abc0",
  null
  
)

export default component.exports